import type { Unsubscribe } from 'firebase/firestore';

/**
 * User profile listen with the same unary fallback as house collections (Cuba).
 */
export function listenUserDoc(
  uid: string,
  onData: (data: Record<string, unknown> | null) => void,
  onError?: () => void,
): Unsubscribe {
  let cancelled = false;
  let unsub: Unsubscribe = () => undefined;

  void Promise.all([
    import('../config/firebase.js'),
    import('firebase/firestore'),
    import('../adapters/data/firebaseSubscribeListen'),
  ]).then(([{ db }, { doc }, { listenDoc }]) => {
    if (cancelled) return;
    unsub = listenDoc(
      doc(db, 'users', uid),
      (snap) => {
        if (cancelled) return;
        const data = snap.data();
        onData(data ? { ...data } : null);
      },
      () => {
        if (!cancelled) onError?.();
      },
    );
    if (cancelled) unsub();
  }).catch(() => {
    if (!cancelled) onError?.();
  });

  return () => {
    cancelled = true;
    unsub();
  };
}
